import { evaluateCondition, readPath } from "../dsl/expression.js";
import { isFlatMenuFormat } from "../dsl/format-catalog.js";
export { isFlatMenuFormat };
export function frameBindingName(entity, as) {
    if (as?.trim())
        return as.trim();
    return entity;
}
/**
 * Default data path when the author leaves `source` empty.
 * Returns `null` when the frame should render once with the entity already in scope.
 */
export function defaultFrameSource(entity, context) {
    if (entity === 'wrapper')
        return null;
    if (entity === 'category') {
        if (context.pageGroup === 'category' &&
            context.scope.category &&
            !isFlatMenuFormat(context.menuFormat)) {
            return null;
        }
        return 'menu.categories';
    }
    if (entity === 'item') {
        if (context.scope.item)
            return null;
        const page = context.scope.page;
        if (Array.isArray(page?.items) && page.items.length > 0)
            return 'page.items';
        return 'category.items';
    }
    return null;
}
export function resolveFrameEntries(node, context) {
    const as = frameBindingName(node.entity, node.as);
    if (node.entity === 'wrapper') {
        return { entries: [], as, iterate: false };
    }
    const source = node.source?.trim() || defaultFrameSource(node.entity, context);
    if (!source) {
        const entry = node.entity === 'category'
            ? context.scope.category
            : node.entity === 'item'
                ? context.scope.item
                : undefined;
        return {
            entries: entry != null ? [entry] : [],
            as,
            iterate: true,
        };
    }
    const raw = readPath(context.scope, source);
    let entries = Array.isArray(raw) ? [...raw] : raw != null ? [raw] : [];
    if (node.filter) {
        entries = entries.filter((entry) => evaluateCondition(node.filter, { ...context.scope, [as]: entry }));
    }
    const offset = node.offset ?? 0;
    entries =
        node.limit === undefined ? entries.slice(offset) : entries.slice(offset, offset + node.limit);
    return { entries, as, iterate: true };
}
//# sourceMappingURL=entity-frame.js.map